import type React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import type { ListingDetails } from 'app/types/listingDetails.type';
import IconViewed from 'images/icons/viewed.svg';
import IconContact from 'images/icons/contact.svg';
import IconWatch from 'images/icons/watch.svg';
import { useContactFormAction } from '../ContactForm/useContactFormAction';
import { ctaButton, ctaEmphasis, icon, row, rowList } from './competitionModule.styles';

type PopularitySummary = {
  viewed?: number;
  inquiries?: number;
};

type LastContacted = {
  ago?: string;
};

type CompetitionListing = ListingDetails & {
  popularity?: {
    summary?: PopularitySummary;
    lastContacted?: LastContacted;
  };
};

export const CompetitionModule: React.FC = () => {
  const listing = useSelector(
    (state: RootReduxState) => state.currentListingDetails?.currentListing as CompetitionListing | undefined,
  );
  const { openContactForm, contactFormOverlay } = useContactFormAction(
    listing,
    'home_details_halo',
    'home_details_component|modal_contact_form',
  );

  const summary = listing?.popularity?.summary;
  const viewed = summary?.viewed ?? 0;
  const inquiries = summary?.inquiries ?? 0;
  const lastContactedAgo = listing?.popularity?.lastContacted?.ago;
  const isActive = listing?.active !== false;

  if (viewed <= 0) return null;

  return (
    <>
      <ul className={rowList}>
        <li className={row}>
          <img src={IconViewed} className={icon} alt="" aria-hidden="true" />
          <span>
            Viewed {viewed} {viewed === 1 ? 'time' : 'times'} this past week.
          </span>
        </li>

        <li className={row}>
          <img src={IconContact} className={icon} alt="" aria-hidden="true" />
          {inquiries > 0 ? (
            <span>
              Contacted {inquiries} {inquiries === 1 ? 'time' : 'times'} in the past week.
            </span>
          ) : (
            <span>
              No one has contacted this listing.{' '}
              {isActive && (
                <button type="button" className={ctaButton} onClick={openContactForm}>
                  Be the <span className={ctaEmphasis}>first</span>!
                </button>
              )}
            </span>
          )}
        </li>

        {lastContactedAgo && (
          <li className={row}>
            <img src={IconWatch} className={icon} alt="" aria-hidden="true" />
            <span>Last contacted {lastContactedAgo}.</span>
          </li>
        )}
      </ul>
      {contactFormOverlay}
    </>
  );
};
